const DEFAULT_END = "0001-01-01T00:00:00.000Z";

export default {
  DEFAULT_END,
}
